<!-- flv格式视频监控组件 -->
<template>
  <div class="video_con">

    <video :id="domId" class="video" muted autoplay controls />

    <!--        <p>执法记录仪 - {{ videoObj.puid }} - <span @click="call(videoObj)">{{ Shout }}</span></p>-->
    <!-- <p>{{ videoObj.Name }} - {{ videoObj.puid }} </p> -->
  </div>
</template>

<script>
import flvjs from 'flv.js'

export default {
  props: {
    videoObj: {
      type: Object,
      monitorUrl: '',
      default: function () {}
    },
    domId: {
      type: String,
      default: ''
    },
    autoLogin: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      flvPlayer: null,
      Shout: '开始喊话'
    }
  },
  watch: {
    videoObj (val) {
      this.createFlvPlayer(val.flvUrl)
    }
  },
  mounted () {
    this.$nextTick(() => {
      console.log('this.videoObj', this.videoObj)
      this.createFlvPlayer(this.videoObj.flvUrl)
    })
  },
  beforeDestroy () {
    this.destroyVideos()
  },
  methods: {
    call (obj) {
      console.log(obj)
    },
    createFlvPlayer (source) {
      console.log('source', source)
      console.log('source', this.domId)
      const _this = this
      if (flvjs.isSupported()) {
        const videoElement = document.getElementById(_this.domId)
        this.flvPlayer = flvjs.createPlayer({
          type: 'flv',
          isLive: true,
          url: source,
          hasAudio: false
        },
        {
          enableWorker: false,
          autoCleanupSourceBuffer: true, // 清理缓冲区
          enableStashBuffer: false,
          stashInitialSize: 128, // 减少首桢显示等待时长
          statisticsInfoReportInterval: 600,
          // 是否启用懒加载功能
          lazyLoad: true,
          lazyLoadMaxDuration: 10, //  最大懒加载时长，单位为秒，默认3设置为为10秒
          lazyLoadRecoverDuration: 60, // 增加延迟加载恢复后的最大等待时间为60秒
          durationAddition: 5 // 添加额外的时间长度
        })
        console.log(this.flvPlayer, 'flv视频对象')

        console.log('videoElement', videoElement)

        this.flvPlayer.attachMediaElement(videoElement)
        this.flvPlayer.load()
        setTimeout(() => {
          this.flvPlayer.play()
        }, 100)
        // FLV 视频数据加载完成后 播放视频
        // this.flvPlayer.load().then(() => this.flvPlayer.play())
        // 监听视频播放器的"statistics_info"事件,解码异常时进行自动恢复操作
        this.flvPlayer.on('STATISTICS_INFO', (res) => {
          if (this.lastDecodedFrame === 0) {
            this.lastDecodedFrame = res.decodedFrames
            return
          }
          if (this.lastDecodedFrame !== res.decodedFrames) {
            this.lastDecodedFrame = res.decodedFrames
          } else {
            this.lastDecodedFrame = 0
            if (this.player) {
              this.reloadVideo()
            }
          }
        })

        // 对象监听
        this.flvPlayer.on('scriptdata_arrived', (e) => {
          console.log('视频正在播放')
        })
        this.flvPlayer.on('error', (e) => {
          console.log('播放出现错误', e)
        })
        // 视频卡顿导致流断了，重连
        this.flvPlayer.on('loading_complete', (errType, errDetail) => {
          // if (this.flvPlayer) {

          console.log('视频到底了')
          // this.destroyVideos()
          // // this.createFlvPlayer(source)
          // this.autoLogin()
          // }
        })
        // 保证实时性，跳帧
        // let timer = setInterval(() => {
        //   if (this.flvPlayer.buffered && this.flvPlayer.buffered.length) {
        //     let end = this.flvPlayer.buffered.end(0) // 获取当前buffered值
        //     let diff = end - this.flvPlayer.currentTime // 获取buffered与currentTime的差值
        //     if (diff >= 60) { // 如果差值大于等于60s 手动跳帧 这里可根据自身需求来定
        //       // 单个视频
        //       // this.flvPlayer.currentTime = end;//手动跳帧
        //       // this.flvPlayer.currentTime = this.flvPlayer.buffered.end(0);//手动跳帧

        //       // 多个视频
        //       clearInterval(timer)
        //       this.flvPlayer.pause()
        //       this.flvPlayer.unload()
        //       this.flvPlayer.detachMediaElement()
        //       this.flvPlayer.destroy()
        //       this.flvPlayer = null
        //       // 重新加载当前停止的视频流，根据个人的方法来配置
        //       this.createdPlay()
        //     }
        //   }
        // }, 2000) // 2000毫秒执行一次
      }
    },
    // 停止流
    destroyVideos () {
      if (!this.flvPlayer) return
      this.flvPlayer.pause()
      this.flvPlayer.unload()
      this.flvPlayer.detachMediaElement()
      this.flvPlayer.destroy()
      this.flvPlayer = null
    }
  }
}
</script>
<style lang="less" scoped>
.video_con {
  width: 90%;
  height: 100%;
  margin: 0 auto;

  video {
    width: 100%;
    height: 100%;
  }

  p {
    width: 100%;
    color: #333;
    margin: 0;
    padding: 5px 10px;
    background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/flvVideo.vue